<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog :title="$t('servicesystem.common_objects.unit.set_unit')" :externaltrigger="dialogtrigger"
      :external-close-trigger="closetrigger">

      <template v-slot:content>
        <v-container :key="dialogtrigger">
          <v-row align="center" no-gutters class="mb-4">
            <v-col cols="0">
              <h6>{{ $t('servicesystem.common_objects.commonterms.on') }}</h6>
              <v-card width="fit-content" class="px-2 py-1" color="primary" dark flat>
                {{ $t('servicesystem.common_objects.machine.selected_machines') }}
              </v-card>
            </v-col>
          </v-row>
          <v-row align="center" no-gutters class="mb-10">
            <v-col>
              <h6>{{ $t('servicesystem.to') }}</h6>
              <CustomerSelect :value="currentCustomerId" disabled>
              </CustomerSelect>
              <UnitSelect v-model="unitId" allowCreate externaledit clearable disableAttach
                :filter="{ CustomerIdList: [currentCustomerId] }" :placeholder="$t('servicesystem.common_objects.unit.no_unit')">
              </UnitSelect>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:buttons>
        <v-btn @click="closetrigger++" color="primary" outlined
          v-text="$t('servicesystem.common_objects.commonterms.cancel')">
        </v-btn>
        <v-btn :loading="loading" color="primary" dark @click="!loading ? save() : null">
          {{ $t('servicesystem.common_objects.commonterms.set') }}
        </v-btn>
      </template>
    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import UnitSelect from "@/components/Inputs/EntityDropdowns/UnitSelect2.vue";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";

export default {
  name: "SetUnitOnMachinesDialog",
  props: {
    externaltrigger: Number,
    currentCustomerId: String,
    saveFunction: {
      type: Function,
      required: true,
    },
  },
  components: {
    SlottedDialog,
    CustomerSelect,
    UnitSelect,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      unitId: null,
      valid: false,
      loading: false,
    };
  },

  methods: {
    async save() {
      this.loading = true;
      await this.saveFunction(this.unitId)
        .then(() => {
          this.closetrigger++;
        })
        .catch(() => { })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  computed: {},

  watch: {
    externaltrigger: function () {
      //console.log("externaltrigger", this.externaltrigger);
      this.unitId = null;
      this.dialogtrigger++;
    },
  },
};
</script>